module.exports = __webpack_public_path__ + "static/media/universe.02b8e1ce.svg";